(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klout-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class KloutAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.klout-ann__item'));
      this._i = 0;
      this._paint(0);
      if (this.items.length < 2) return;
      const speed = (parseFloat(this.dataset.speed) || 4) * 1000;
      this._timer = setInterval(() => this._next(), speed);
    }
    disconnectedCallback() {
      clearInterval(this._timer);
    }
    _next() {
      const prev = this.items[this._i];
      prev.classList.remove('is-active');
      prev.classList.add('is-prev');
      setTimeout(() => prev.classList.remove('is-prev'), 650);
      this._i = (this._i + 1) % this.items.length;
      const cur = this.items[this._i];
      cur.classList.add('is-active');
      this._paint(this._i);
    }
    _paint(i) {
      const it = this.items[i];
      if (it && it.dataset.bg) this.style.background = it.dataset.bg;
    }
  }
  customElements.define('klout-announcement', KloutAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klout-best-sellers"] && !Shopify.designMode) return;
  try {
    
  class KloutCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.kbs__viewport');
      this.track = this.querySelector('.kbs__track');
      if (!this.track) return;
      this.reals = Array.prototype.slice.call(this.track.children);
      this.n = this.reals.length;
      if (this.n === 0) return;

      this.clones = [];
      if (this.n > 1) {
        var before = document.createDocumentFragment();
        var after = document.createDocumentFragment();
        var store = this.clones;
        this.reals.forEach(function (el) {
          var b = el.cloneNode(true); b.setAttribute('aria-hidden', 'true'); store.push(b); before.appendChild(b);
          var a = el.cloneNode(true); a.setAttribute('aria-hidden', 'true'); store.push(a); after.appendChild(a);
        });
        this.track.insertBefore(before, this.reals[0]);
        this.track.appendChild(after);
      }
      this.items = Array.prototype.slice.call(this.track.children);
      this.animating = false;
      this.pos = null;
      this.mode = null;

      var self = this;
      this.track.addEventListener('click', function (e) {
        var sw = e.target.closest('.kbs-card__swatch');
        if (!sw) return;
        var card = sw.closest('.kbs-card');
        var img = card && card.querySelector('.kbs-card__img');
        if (img && sw.dataset.full) { img.removeAttribute('srcset'); img.src = sw.dataset.full; }
        card.querySelectorAll('.kbs-card__swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
      });

      this.track.addEventListener('transitionend', function (e) {
        if (e.target !== self.track || e.propertyName !== 'transform') return;
        self.animating = false;
        if (self.mode === 'center') self.normalize();
      });

      this.apply();
      window.addEventListener('resize', function () { self.apply(); });
    }

    activate() { this.apply(); }

    apply() {
      if (!this.track) return;
      // Siempre scroll nativo con snap (deslizable en móvil y desktop).
      this.classList.add('kbs__carousel--row');
      this.gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
      var vpW = this.viewport.clientWidth;
      if (vpW === 0) return; // oculto: se reaplica al activarse
      // Los clones del loop infinito no se usan en modo scroll → ocultarlos.
      this.clones.forEach(function (c) { c.style.display = 'none'; });
      this.items.forEach(function (it) { it.classList.remove('is-current'); });
      if (window.innerWidth >= 990) {
        var visible = window.innerWidth >= 1200 ? 4 : 3;
        this.cardW = Math.round((vpW - (visible - 1) * this.gap) / visible);
      } else {
        // Móvil: tarjeta ~66% del viewport → se ve media miniatura de la siguiente.
        this.cardW = Math.round(vpW * 0.66);
      }
      this.style.setProperty('--kbs-card-w', this.cardW + 'px');
      this.mode = 'row';
    }

    onArrow(dir) {
      var by = (this.cardW + this.gap) * (window.innerWidth >= 990 ? 2 : 1);
      this.viewport.scrollBy({ left: dir > 0 ? by : -by, behavior: 'smooth' });
    }

    go(dir) {
      if (this.n <= 1 || this.animating) return;
      this.animating = true;
      this.pos += dir;
      this.place(true);
      var self = this;
      clearTimeout(this._t);
      this._t = setTimeout(function () { if (self.animating) { self.animating = false; self.normalize(); } }, 600);
    }

    place(animate) {
      var vpW = this.viewport.clientWidth;
      var outer = this.cardW + this.gap;
      var x = (vpW / 2) - (this.pos * outer) - (this.cardW / 2);
      if (!animate) { this.track.style.transition = 'none'; }
      this.track.style.transform = 'translateX(' + x + 'px)';
      if (!animate) { void this.track.offsetWidth; this.track.style.transition = ''; }
      var self = this;
      this.items.forEach(function (it, i) { it.classList.toggle('is-current', i === self.pos); });
    }

    normalize() {
      if (this.n <= 1) return;
      if (this.pos < this.n) { this.pos += this.n; this.place(false); }
      else if (this.pos >= this.n * 2) { this.pos -= this.n; this.place(false); }
    }
  }
  customElements.define('klout-carousel', KloutCarousel);

  // Controlador de pestañas + flechas por sección
  (function () {
    function initSection(section) {
      if (!section || section.dataset.kbsInit) return;
      section.dataset.kbsInit = '1';
      var tabs = Array.prototype.slice.call(section.querySelectorAll('.kbs__tab'));
      var carousels = Array.prototype.slice.call(section.querySelectorAll('.kbs__carousel'));
      function activate(idx) {
        idx = String(idx);
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.tab === idx); });
        carousels.forEach(function (c) {
          var on = c.dataset.tab === idx;
          c.classList.toggle('is-active', on);
          if (on && typeof c.activate === 'function') c.activate();
        });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.dataset.tab); }); });
      section.querySelectorAll('.kbs__arrow').forEach(function (b) {
        b.addEventListener('click', function () {
          var active = section.querySelector('.kbs__carousel.is-active');
          if (active && typeof active.onArrow === 'function') active.onArrow(b.dataset.dir === 'next' ? 1 : -1);
        });
      });
    }
    function run() { document.querySelectorAll('.kbs').forEach(initSection); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.classList && e.target.classList.contains('kbs')) initSection(e.target);
      else if (e.target.querySelector) initSection(e.target.querySelector('.kbs'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klout-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMarquee(m) {
      var track = m.querySelector('.klout-marquee__track');
      if (!track) return;
      var speed = parseFloat(m.dataset.speed) || 95;
      function setDur() {
        var half = track.scrollWidth / 2;
        if (half > 0) track.style.animationDuration = (half / speed).toFixed(2) + 's';
      }
      setDur();
      window.addEventListener('resize', setDur);
    }
    function run() {
      document.querySelectorAll('.klout-marquee').forEach(initMarquee);
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.querySelectorAll('video.klout-hero__bg-video').forEach(function (v) {
          v.removeAttribute('autoplay');
          v.pause();
        });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klout-newsletter-popup"]) return;
  try {
    
    class KloutPopup extends HTMLElement {
      connectedCallback() {
        this.days = parseFloat(this.dataset.days) || 7;
        this.delay = (parseFloat(this.dataset.delay) || 18) * 1000;
        if (this.suppressed()) { this.remove(); return; }
        var self = this;
        this.querySelectorAll('[data-kpop-close]').forEach(function (el) {
          el.addEventListener('click', function () { self.close(); });
        });
        this._esc = function (e) { if (e.key === 'Escape') self.close(); };
        document.addEventListener('keydown', this._esc);
        var form = this.querySelector('form');
        if (form) form.addEventListener('submit', function () { self.mark('sub'); });
        this._timer = setTimeout(function () { self.open(); }, this.delay);
        this._exit = function (e) { if (e.clientY <= 0) self.open(); };
        if (window.matchMedia('(min-width: 990px)').matches) {
          document.addEventListener('mouseout', this._exit);
        }
      }
      suppressed() {
        try {
          if (sessionStorage.getItem('klout_nl_seen')) return true;
          var v = localStorage.getItem('klout_nl');
          if (!v) return false;
          if (v === 'sub') return true;
          var t = parseInt(v, 10);
          if (t && (Date.now() - t) < this.days * 86400000) return true;
        } catch (e) {}
        return false;
      }
      open() {
        if (this.opened) return;
        this.opened = true;
        clearTimeout(this._timer);
        document.removeEventListener('mouseout', this._exit);
        this.hidden = false;
        var self = this;
        requestAnimationFrame(function () { self.classList.add('is-open'); });
        try { sessionStorage.setItem('klout_nl_seen', '1'); } catch (e) {}
        document.body.style.overflow = 'hidden';
      }
      close() {
        this.classList.remove('is-open');
        document.body.style.overflow = '';
        this.mark(String(Date.now()));
        var self = this;
        setTimeout(function () { self.hidden = true; }, 300);
      }
      mark(v) { try { localStorage.setItem('klout_nl', v); } catch (e) {} }
      disconnectedCallback() {
        document.removeEventListener('keydown', this._esc);
        document.removeEventListener('mouseout', this._exit);
      }
    }
    customElements.define('klout-popup', KloutPopup);
  
  } catch(e) { console.error(e); }
})();
})();
